var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_4709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83073C2.5 5.3887 2.67559 4.96478 2.98816 4.65222C3.30072 4.33966 3.72464 4.16406 4.16667 4.16406H15.8333C16.2754 4.16406 16.6993 4.33966 17.0118 4.65222C17.3244 4.96478 17.5 5.3887 17.5 5.83073V14.1641C17.5 14.6061 17.3244 15.03 17.0118 15.3426C16.6993 15.6551 16.2754 15.8307 15.8333 15.8307H4.16667C3.72464 15.8307 3.30072 15.6551 2.98816 15.3426C2.67559 15.03 2.5 14.6061 2.5 14.1641V5.83073Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83594L10 10.8359L17.5 5.83594",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_4709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.15c4df1fb93d588baa5d2739bc5f72d0.svg";
export { ForwardRef as ReactComponent };